import WRAP from "WRAP-JS";
import { COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../../../constants/ErrorMessage";
import { CONTENTS_ID_POWER_LINES, CONTENTS_ID_POWER_LINES_SNK } from "../../../store/DisabledContentsState";
import { MAP_ID_POWER_LINES } from "../../../store/MapContentsState";
import { configPowerLineCHUDENDh, configPowerLineDh, configPowerLineLayer, configPowerLineTEPCODh } from "./config/ConfigPowerLine";

class PowerLine {
  static NAME = MAP_ID_POWER_LINES;
  static WHOLE_COUNTRY = `${PowerLine.NAME}_WHOLE_COUNTRY`;
  static TEPCO = `${PowerLine.NAME}_TEPCO`;
  static CHUDEN = `${PowerLine.NAME}_CHUDEN`;
  static CONTENTS_VISIBLE_STATE_DEFAULT = {
    [PowerLine.WHOLE_COUNTRY]: true
  };
  static CONTENTS_VISIBLE_STATE_DEFAULT_SNK = {
    [PowerLine.TEPCO]: true,
    [PowerLine.CHUDEN]: true
  };

  defaultState;
  contentsVisibleState;

  dhPowerLine;
  layerPowerLine;
  ready = false;
  contentsType;
  layers = {
    [CONTENTS_ID_POWER_LINES]: [
      {name: PowerLine.WHOLE_COUNTRY}
    ],
    [CONTENTS_ID_POWER_LINES_SNK]: [
      {name: PowerLine.TEPCO},
      {name: PowerLine.CHUDEN}
    ]
  }
  dhs = {
    [CONTENTS_ID_POWER_LINES]: [
      {name: PowerLine.WHOLE_COUNTRY, conf: configPowerLineDh}
    ],
    [CONTENTS_ID_POWER_LINES_SNK]: [
      {name: PowerLine.TEPCO, conf: configPowerLineTEPCODh},
      {name: PowerLine.CHUDEN, conf: configPowerLineCHUDENDh}
    ]
  }
  prefixes = {}
  contentsDispatcher;
  errorMessageInfo = {};
  visible;

  constructor(disabled) {
    if (!disabled[CONTENTS_ID_POWER_LINES_SNK]) {
      this.contentsType = CONTENTS_ID_POWER_LINES_SNK;
      this.defaultState = PowerLine.CONTENTS_VISIBLE_STATE_DEFAULT_SNK;
      this.contentsVisibleState = {...PowerLine.CONTENTS_VISIBLE_STATE_DEFAULT_SNK};
    } else {
      this.contentsType = CONTENTS_ID_POWER_LINES;
      this.defaultState = PowerLine.CONTENTS_VISIBLE_STATE_DEFAULT;
      this.contentsVisibleState = {...PowerLine.CONTENTS_VISIBLE_STATE_DEFAULT};
    }

    this.layers[this.contentsType].forEach(l => {
      l.layer = new WRAP.Geo.Layer(l.name);
      l.layer.setVisible(false);
      l.layer.disableInteraction(true);
    });
  }

  async _initData(name) {
    return new Promise((resolve, reject) => {
      const dh = this.dhs[this.contentsType].find(dh => dh.name === name);
      dh.dh = new WRAP.Data(dh.conf);
      dh.dh.updated('index', ref => {
        if (this.errorMessageInfo[name]) {
          this.contentsDispatcher({type: 'CLEAR_ERROR', payload: this.errorMessageInfo[name]});
          this.errorMessageInfo[name] = null;
        }
        this.prefixes[name] = ref[0].Prefix;
        resolve(dh.dh);
      }, () => {
        this.errorMessageInfo[name] = this.contentsDispatcher({type: 'SHOW_ERROR', payload: {
          message: dh.dh.conf.apiName,
          additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
        }});
        reject();
      });
    });
  }

  _initLayer(name, dh) {
    const layer = this.layers[this.contentsType].find(layer => layer.name === name);
    layer.layer.configure(dh, configPowerLineLayer);
    layer.layer.set({prefix: this.prefixes[name]});
  }

  async drawLayer(visible) {
    this.visible = visible;
    await this.setVisible(visible);
  }

  getLayer() {
    return this.layers[this.contentsType].map(l => l.layer);
  }

  async setVisible(visible) {
    if (visible) {
      for await (const key of Object.keys(this.contentsVisibleState)) {
        await this._setContentsVisible(key);
      }
    } else {
      this.layers[this.contentsType].forEach(l => {
        l.layer.hide();
      });
    }
  }

  getContentsVisibleState() {
    return this.contentsVisibleState;
  }

  resetContentsVisibleState() {
    this.contentsVisibleState = {...this.defaultState};
  }

  async _setContentsVisible(name) {
    const layer = this.layers[this.contentsType].find(l => l.name === name);
    if (this.contentsVisibleState[name] && this.visible) {
      if (!this.prefixes[name]) {
        try {
          const dh = await this._initData(name);
          if (dh) {
            this._initLayer(name, dh);
            layer.layer.show();
          }
        } catch {
          console.log('powerLine load error');
        }
      } else {
        layer.layer.show();
      }
    } else {
      layer.layer.hide();
    }
  }

  setContentsVisible(name, visible) {
    this.contentsVisibleState[name] = visible;
    this._setContentsVisible(name, visible);
  }
  setContentsDispatcher(dispatcher) {
    this.contentsDispatcher = dispatcher;
  }

}

export default PowerLine;
